import React from 'react'

import { PREMIUM_LEGACY_POST_LOGIN_URL } from '../../../utils/Constants'

export const PostLoginPage = React.memo(() => {
  const loginPageUrl = PREMIUM_LEGACY_POST_LOGIN_URL + window.location.search
  window.location.href = loginPageUrl
  return <></>
})
